import { render, staticRenderFns } from "./ServiceNumberMinutesOfUseLineChart.vue?vue&type=template&id=6234a21a&scoped=true&"
import script from "./ServiceNumberMinutesOfUseLineChart.vue?vue&type=script&lang=js&"
export * from "./ServiceNumberMinutesOfUseLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6234a21a",
  null
  
)

export default component.exports